
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"23","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"toStroke",attrs:{"d":"M5.877 6.717v3.561c0 .778.485 1.472 1.214 1.741 1.798.663 3.596.994 5.395.994 1.798 0 3.596-.331 5.394-.994a1.855 1.855 0 001.214-1.74V6.302","stroke":"#042132","stroke-width":"1.4"}}),_c('path',{staticClass:"toStroke",attrs:{"d":"M11.35 8.8L.71 4.962l10.727-3.573a3.474 3.474 0 012.303.038l9.552 3.535-9.47 3.797c-.79.317-1.67.332-2.472.043z","stroke":"#042132","stroke-width":"1.4"}}),_c('path',{staticClass:"toStroke",attrs:{"d":"M21.517 5.476V9.2","stroke":"#042132","stroke-width":"1.4","stroke-linecap":"square"}})])
          )
        }
      }
    